

export class EmployeeGroupAllOutput implements IEmployeeGroupAllOutput {
    /** The auto-generated id of the employee group master */
    employee_group_id!: number;
    /** The user group name with 255 character limit */
    employee_group_name!: string;
    /** The description with 5000 character limit */
    description!: string;
    /** Manage status of user group. 0 For De-active, 1 For Active */
    status!: number;
    /** The company name with 255 character limit */
    company_name!: string;
    /** The selected branches of employee */
    branches!: string;

    constructor(data?: IEmployeeGroupAllOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employee_group_id = _data["employee_group_id"];
            this.employee_group_name = _data["employee_group_name"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.company_name = _data["company_name"];
            this.branches = _data["branches"];
        }
    }

    static fromJS(data: any): EmployeeGroupAllOutput {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeGroupAllOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee_group_id"] = this.employee_group_id;
        data["employee_group_name"] = this.employee_group_name;
        data["description"] = this.description;
        data["status"] = this.status;
        data["company_name"] = this.company_name;
        data["branches"] = this.branches;
        return data; 
    }
}

export interface IEmployeeGroupAllOutput {
    /** The auto-generated id of the employee group master */
    employee_group_id: number;
    /** The user group name with 255 character limit */
    employee_group_name: string;
    /** The description with 5000 character limit */
    description: string;
    /** Manage status of user group. 0 For De-active, 1 For Active */
    status: number;
    /** The company name with 255 character limit */
    company_name: string;
    /** The selected branches of employee */
    branches: string;
}

